import script from "./UserNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./UserNavbar.vue?vue&type=style&index=0&id=737fcc2c&lang=css"

const __exports__ = script;

export default __exports__